import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import Layout from '../components/Layout';
import { blogService } from '../services/firebaseService';
import { BlogPost } from '../types';
import { Timestamp } from 'firebase/firestore';

const BlogPage: React.FC = () => {
  const [posts, setPosts] = useState<BlogPost[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    blogService.getBlogPosts().then(list => {
      setPosts(list);
      setLoading(false);
    }).catch((error) => {
      console.error('Error loading blog posts:', error);
      setLoading(false);
    });
  }, []);

  const formatDate = (timestamp: unknown) => {
    if (!timestamp) return '';
    let date: Date;
    if (timestamp instanceof Timestamp) {
      date = timestamp.toDate();
    } else if (timestamp instanceof Date) {
      date = timestamp;
    } else {
      date = new Date(timestamp as any);
    }
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  };

  const getExcerpt = (content: string, excerpt?: string) => {
    if (excerpt) return excerpt;
    // Get first 200 characters or first paragraph
    const firstParagraph = content.split('\n\n')[0];
    if (firstParagraph.length <= 200) return firstParagraph;
    return firstParagraph.substring(0, 200) + '...';
  };

  return (
    <Layout>
      <div className="container">
        <h1>Blog</h1>
        {loading ? (
          <div className="loading"><div className="spinner" /></div>
        ) : posts.length === 0 ? (
          <div className="card">
            <p>No blog posts yet. Check back soon!</p>
          </div>
        ) : (
          <div className="grid">
            {posts.map((post) => (
              <Link 
                to={`/blog/${post.id}`} 
                key={post.id}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <div className="card" style={{ cursor: 'pointer' }}>
                  <h3 style={{ whiteSpace: 'pre-line' }}>{post.title}</h3>
                  {post.author && (
                    <p style={{ color: 'var(--text-light)', fontSize: '0.9rem', marginBottom: '0.5rem' }}>
                      Written by: {post.author}
                    </p>
                  )}
                  {post.publishedAt && (
                    <p style={{ color: 'var(--text-light)', fontSize: '0.9rem', marginBottom: '1rem' }}>
                      {formatDate(post.publishedAt)}
                    </p>
                  )}
                  <div style={{ color: 'var(--text-dark)' }}>
                    <ReactMarkdown
                      components={{
                        p: ({ children }) => <p style={{ marginBottom: '0.5rem' }}>{children}</p>
                      }}
                    >
                      {getExcerpt(post.content, post.excerpt)}
                    </ReactMarkdown>
                  </div>
                  <Link 
                    to={`/blog/${post.id}`}
                    className="btn btn-primary"
                    style={{ marginTop: '1rem', display: 'inline-block' }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    Read More →
                  </Link>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
};

export default BlogPage;

